module.exports = require('./dist/athlib.web.js');



//////////////////
// WEBPACK FOOTER
// ./~/athlib/index.js
// module id = 200
// module chunks = 1